import Testimonials3 from './Testimonials3'
export default Testimonials3
